class HomepageNavigationGrid extends HTMLElement {
  constructor() {
    super();
    this.loadMoreBtn = this.querySelector('.homepage-navigation-grid__load-more');
    this.hiddenItems = this.querySelectorAll('.homepage-navigation-grid__item.is-hidden');
    this.textElement = this.querySelector('.homepage-navigation-grid__load-more-text');
    this.iconPlus = this.querySelector('.homepage-navigation-grid__load-more-icon-plus');
    this.iconMinus = this.querySelector('.homepage-navigation-grid__load-more-icon-minus');
    this.isExpanded = false;
  }

  connectedCallback() {
    if (this.loadMoreBtn && this.hiddenItems.length > 0) {
      this.#setupListeners();
    }
  }

  #setupListeners() {
    this.loadMoreBtn.addEventListener('click', this.#toggleItems.bind(this));
  }

  #toggleItems() {
    this.isExpanded = !this.isExpanded;
    
    this.hiddenItems.forEach((item) => {
      if (this.isExpanded) {
        item.classList.remove('is-hidden');
      } else {
        item.classList.add('is-hidden');
      }
    });

    if (this.isExpanded) {
      if (this.textElement) this.textElement.textContent = this.loadMoreBtn.dataset.textLess;
      if (this.iconPlus) this.iconPlus.classList.add('hidden');
      if (this.iconMinus) this.iconMinus.classList.remove('hidden');
    } else {
      if (this.textElement) this.textElement.textContent = this.loadMoreBtn.dataset.textMore;
      if (this.iconMinus) this.iconMinus.classList.add('hidden');
      if (this.iconPlus) this.iconPlus.classList.remove('hidden');
    }
  }
}

if (!customElements.get('homepage-navigation-grid')) {
  customElements.define('homepage-navigation-grid', HomepageNavigationGrid);
}
